<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="row" v-if="!loading">
            <div class="col-lg-12 mb-4">
                <UserInfoBlock
                    :user="dataInfoBlock"
                ></UserInfoBlock>
            </div>
            <div class="col-lg-12 mb-4">
                <UserTabsContainer
                    :changing-password="changingPassword"
                    :view-notes-by-admin="viewNotesByAdmin"
                    :view-notes-on-admin="viewNotesOnAdmin"
                    :view-admin-permissions="viewAdminPermissions"
                    :user="user"
                    :list-of-permissions="permissionsCategories"
                ></UserTabsContainer>
            </div>
        </div>
    </div>


</template>

<script>


import UserInfoBlock from "./UserInfoBlock.vue";
import UserTabsContainer from "./UserTabsContainer.vue";
import UsersServices from "./services/UsersServices";

export default {
    name: 'UserPage',
    props: {
        viewNotesByAdmin: {
            type: Boolean,
            required: true,
        },
        viewNotesOnAdmin: {
            type: Boolean,
            required: true,
        },
        viewAdminPermissions: {
            type: Boolean,
            required: true,
        },
        changingPassword: {
            type: Boolean,
            required: true,
        },
        user: {
            type: Object,
            required: true
        },
        permissionsCategories: {
            type: Array
        }
    },
    components: {
        UserTabsContainer,
        UserInfoBlock,
    },
    data() {
        return {
            loading: false,
            dataInfoBlock: {
                job_title: null,
                name: null,
                last_name: null,
                status: null,
            },

        }
    },
    methods: {
        setData() {
            Object.keys(this.dataInfoBlock).forEach((key) => {
                if (this.user.hasOwnProperty(key)) {
                    this.dataInfoBlock[key] = this.user[key];
                }
            });
        },
    },
     mounted() {
        this.setData()
    },
}

</script>

<style scoped>

</style>
